import { render, staticRenderFns } from "./QueryManagement.vue?vue&type=template&id=5fb16bd5&scoped=true&"
import script from "./QueryManagement.vue?vue&type=script&lang=js&"
export * from "./QueryManagement.vue?vue&type=script&lang=js&"
import style0 from "./QueryManagement.vue?vue&type=style&index=0&id=5fb16bd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb16bd5",
  null
  
)

export default component.exports